import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { endpoints } from '../services/api';
import AuthShell from '../components/AuthShell';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <AuthShell display="Link expired." say="Reset links only last a short while. Ask for a fresh one.">
          <h1 className="auth-title">This link doesn’t work</h1>
          <p className="auth-error">This password reset link is invalid or has expired.</p>
          <p className="auth-switch">
            <Link to="/forgot-password">Request a new link</Link>
          </p>
      </AuthShell>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(endpoints.auth.resetPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });

      const data = await res.json();

      if (!res.ok) {
        if (data.detail === 'token_expired') {
          throw new Error('This link has expired. Please request a new one.');
        }
        if (data.detail === 'invalid_token') {
          throw new Error('This link is invalid. Please request a new one.');
        }
        throw new Error(data.detail || 'Something went wrong.');
      }

      navigate('/login?reset=success');
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell display="New password." say="Pick something at least 8 characters long.">
        <h1 className="auth-title">Set a new password</h1>
        <p className="auth-subtitle">Enter your new password below.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <p className="auth-error">{error}</p>}

          <div className="form-group">
            <label htmlFor="password">New password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              minLength={8}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirm">Confirm new password</label>
            <input
              type="password"
              id="confirm"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={8}
            />
          </div>

          <button
            type="submit"
            className="cta-button primary auth-button"
            disabled={loading}
          >
            {loading ? 'Saving…' : 'Set new password'}
          </button>
        </form>

        {error && (error.includes('expired') || error.includes('invalid')) && (
          <p className="auth-switch">
            <Link to="/forgot-password">Request a new reset link</Link>
          </p>
        )}
    </AuthShell>
  );
};

export default ResetPasswordPage;
